import { getApi } from "./api_instance";

export const fetchProjectById = async (projectId, userId, dispatch) => {
  try {
    const { data } = await getApi({
      apiUrl: `/projects/api/getProjectDetails?projectId=${projectId}&userId=${userId}`,
      sendToken: true,
      dispatch,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
